import { createAsyncThunk } from '@reduxjs/toolkit';
import { SilentThunkError } from '@socialive/common';
import client from '../../../services/api-client';
import selectApiBaseUrl from '../../env/selectors/selectApiBaseUrl';
import { selectTrayAccountId, selectTrayUserId } from '../selectors';

export default createAsyncThunk('connectionManager/fetchTrayUserToken', async ({ accountId }, { getState }) => {
  const apiBaseUrl = selectApiBaseUrl(getState());
  const trayUserId = selectTrayUserId(getState());

  const url = `${apiBaseUrl}/workflows/create-user-token/${trayUserId}`;

  const response = await client(url, { method: 'POST' });
  const trayUserToken = response?.data?.authorize?.accessToken;

  if (!trayUserToken) {
    throw new SilentThunkError('token no found');
  }

  if (accountId !== selectTrayAccountId(getState()) || trayUserId !== selectTrayUserId(getState())) {
    throw new SilentThunkError('trayAccountId changed during processing');
  }

  return trayUserToken;
});
